// src/config.js
const AppConfig = {
    title: "S4raa - On Tiktok",
    paragraph: "سارا",
    img: "https://i.postimg.cc/3816SpVT/Screenshot-20250707-220008-Gallery.jpg",
    url: "s4arass",
    id: "8070725"
};

export default AppConfig;
